import React from "react";

const AppButton = ({
  children,
  type = "button",
  variant = "primary",
  fullWidth = true,
  disabled = false,
  loading = false,
  onClick,
  className = "",
}) => {
  return (
    <button
      type={type}
      disabled={disabled || loading}
      onClick={onClick}
      className={`
        inline-flex
        h-[48px]
        items-center
        justify-center
        rounded-[9px]
        px-5
        font-['Inter']
        text-[12px]
        font-semibold
        transition-all
        duration-200

        ${
          variant === "primary"
          ? `
          bg-[linear-gradient(180deg,#6fa142_0%,#4c7a2e_55%,#375c20_100%)]
              border
              border-[#4c7a2e]
              text-white
              hover:-translate-y-px
              hover:border-[#375c20]
              hover:bg-[#375c20]
              hover:shadow-[#375c20]
            `
            // ? `
            //   border
            //   border-[#20485b]
            //   bg-[#20485b]
            //   text-white
            //   shadow-[0_7px_18px_rgba(32,72,91,0.22)]
            //   hover:-translate-y-px
            //   hover:border-[#173d4f]
            //   hover:bg-[#173d4f]
            //   hover:shadow-[0_9px_22px_rgba(32,72,91,0.28)]
            // `
            : `
              border
              border-[#e2e4e6]
              bg-white
              text-[#263b47]
              hover:bg-[#fafafa]
              hover:border-[#173d4f]
            `
        }

        ${fullWidth ? "w-full" : ""}

        ${
          disabled || loading
            ? "cursor-not-allowed opacity-60"
            : "cursor-pointer"
        }

        ${className}
      `}
    >
      {loading ? "Please wait..." : children}
    </button>
  );
};

export default AppButton;